"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const convertJsPdfToFormData_1 = __importDefault(require("../../../../app/bbva/application/convertJsPdfToFormData"));
const findBbvaByCriteria_1 = require("../../../../app/bbva/application/findBbvaByCriteria");
const generateAmortizationTableInPdf_1 = __importDefault(require("../../../../app/bbva/application/generateAmortizationTableInPdf"));
const bbvaRepository_1 = __importDefault(require("../../../../app/bbva/infraestructure/repositories/bbvaRepository"));
const useErrorModal_1 = __importDefault(require("../../../../app/shared/utils/useErrorModal"));
const useUrl_1 = require("../../../../hooks/useUrl");
const useBbvaStore_1 = require("../../../../stores/useBbvaStore");
const useSimulationStore_1 = require("../../../../stores/useSimulationStore");
const animated_placeholder_vue_1 = __importDefault(require("../atoms/animated-placeholder.vue"));
const leading_step_vue_1 = __importDefault(require("../atoms/leading-step.vue"));
const modal_vue_1 = __importDefault(require("./modal.vue"));
const moment_1 = __importDefault(require("moment"));
const loading_modal_vue_1 = __importDefault(require("../../../organisms/loading-modal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'step-bbva',
    setup(__props) {
        const store = (0, useSimulationStore_1.useSimulationStore)();
        const bbvaStore = (0, useBbvaStore_1.useBbvaStore)();
        const { createCotizationUrl } = (0, useUrl_1.useUrl)();
        const step4 = (0, vue_2.ref)(null);
        const step5 = (0, vue_2.ref)(null);
        const modalOptions = (0, useErrorModal_1.default)(false);
        const loading = (0, vue_2.ref)(false);
        const downloading = (0, vue_2.ref)(false);
        const currentStep = (0, vue_2.ref)(1);
        var btnSeguro = (0, vue_2.ref)("");
        const btnGarantia = (0, vue_2.ref)();
        const guaranteeInputs = (0, vue_2.ref)({
            guaranteeExtented: true,
            guaranteeType: "Financiado"
        });
        const cotizationUrl = '#';
        const exportAmortizationTable = async () => {
            try {
                downloading.value = true;
                const bbvaResponse = await (0, bbvaRepository_1.default)().syncCotization({
                    bbva_api_call_id: bbvaStore.data?.bbva_quotation_id ?? 0,
                    bbva_app_id: store.powerTrain?.bbva_app_id,
                    casualtyInsurance: store.hasInsurance,
                    enganche: bbvaStore.engancheAmount,
                    marketValue: store.powerTrain?.price,
                    plazo: bbvaStore.plazo,
                    vehicle_id: store.powerTrain?.id,
                    year: store.powerTrain?.trim?.model?.year
                });
                const tableRows = bbvaStore.data?.installmentPlan.scheduledPayments;
                if (!tableRows) {
                    throw new Error("Funding empty");
                }
                const pdfFile = (0, generateAmortizationTableInPdf_1.default)(bbvaStore.data, store.powerTrain, bbvaStore.engancheAmount, bbvaStore.plazo, store.hasInsurance);
                const fileName = `Tabla de amortización BBVA - ${bbvaResponse.bbva_folio}`;
                const formData = (0, convertJsPdfToFormData_1.default)(pdfFile, fileName);
                await (0, bbvaRepository_1.default)().uploadPdf(formData);
                pdfFile.save(fileName);
            }
            finally {
                downloading.value = false;
            }
        };
        const handlePreAuthorization = () => {
            store.activeComponent = "bbvaFormF2";
        };
        const handleInsuranceClick = async (isAccepted) => {
            step5.value?.scrollIntoView({ behavior: "smooth", block: "center" });
            loading.value = true;
            currentStep.value = 1;
            if (isAccepted) {
                btnSeguro.value = "yes";
            }
            else {
                btnSeguro.value = "no";
            }
            try {
                bbvaStore.data = await (0, findBbvaByCriteria_1.findBbvaByCriteria)({
                    enganchePercentage: bbvaStore.enganchePercentage,
                    plazo: bbvaStore.plazo,
                    powerTrain: store.powerTrain,
                    seguro: isAccepted
                });
                store.hasInsurance = isAccepted;
                currentStep.value = 2;
            }
            catch (e) {
                modalOptions.open = true;
                modalOptions.message = e.message;
            }
            finally {
                loading.value = false;
            }
        };
        (0, vue_2.onMounted)(() => {
            step4.value?.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return { __sfc: true, store, bbvaStore, createCotizationUrl, step4, step5, modalOptions, loading, downloading, currentStep, btnSeguro, btnGarantia, guaranteeInputs, cotizationUrl, exportAmortizationTable, handlePreAuthorization, handleInsuranceClick, AnimatedPlaceholder: animated_placeholder_vue_1.default, LeadingStep: leading_step_vue_1.default, Modal: modal_vue_1.default, moment: moment_1.default, LoadingModal: loading_modal_vue_1.default };
    }
});
